<template>
  <vue-apex-charts
    ref="competitionChartDonut"
    height="450"
    :options="chartOptionsDonut"
    :series="series"
    :totalFreq="totalFreq"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";



export default {
  name: "CompetitionChartDonut",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsDonut: {
        chart: {
          type: "donut",
        },
        // labels: ['국민의힘', '더불어민주당', '개혁신당', '민주노동당', '무소속', '기타'],
        labels: ['국민의힘', '더불어민주당', '개혁신당', '진보당', '정의당', '조국혁신당', '자유와혁신', '기본소득당', '새미래민주당', '무소속', '기타'],
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
        },
        // colors: ["#E60024", "#162583", "#FF7920", "#F5EB1B", "#ADAEB3", "#808080"],
        colors: ["#E60024", "#162583", "#FF7920", "#A30617", "#FFED00", "#1F96DE", "#830029", "#00FFDF", "#4FB4B9", "#ADAEB3", "#808080"],
        tooltip: {
          enabled: false,
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 10,
            vertical: 10,
          },
          markers: {
            size: 5,
            offsetX: 10,
            offsetY: 0,
            strokeWidth: 0,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,                
                total: {
                  show:true,
                  label: "총 검색량",
                  fontSize: "22px",
                  fontWeight: "bold",
                  fontFamily: 'NanumBarunGothic, Arial, sans-serif !important',
                  formatter(w){
                    let completionSum=0;
                    return w.globals.seriesTotals.reduce((a,b,c,d)=>{
                      completionSum= d[0]+d[1]
                      return completionSum.toLocaleString();
                    },0)
                  }
                },
                value: {
                  show: true,
                  formatter(val){
                    return parseFloat(val).toLocaleString()
                  }
                }
              },
            },
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#404040',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },
      
      series: [],

      totalFreq: "0"
    };
  },
  props: {
    donutChartData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    donutChartData() {
      this.series = []

      for (const data of this.donutChartData) {
        this.series.push(data);
      }

      this.$refs.competitionChartDonut.updateOptions({
        series: [{
          data: this.series
        }]
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
